import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class TipoGastosService {
  controller: string = "tipo-gastos/";
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  select(user: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'select', { usuario: user }, this.sesion.headers);
  }

  create(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', { tipo_gasto: data }, this.sesion.headers);
  }
  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "view/" + id, this.sesion.headers);
  }
  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + data.id, {tipo_gasto :data}, this.sesion.headers);
  }
  delete(data: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'delete/' + data, this.sesion.headers);
  }
}
